import axios from 'axios';

let instance;

function getAdvancedQuery(query = '', includeTerms = '', excludeTerms = '') {
    const re = /[ ,]+/;
    let advancedQuery = query.trim();
    if (includeTerms) {
        advancedQuery += ` ${includeTerms.split(re).join(' ').trim()}`;
    }
    if (excludeTerms) {
        advancedQuery += ` -${excludeTerms.split(re).join(' -').trim()}`;
    }
    return advancedQuery.trim();
}

const service = {
    async getList(options = {}) {
        const params = {
            '-categories': options.excludeCategories || null,
            '-tags': options.excludeTags || null,
            page: options.page || 1,
            per_page: options.per_page || 6,
            tags: options.includeTags || null,
            categories: options.includeCategories || null,
            locations: options.locations || null,
        };

        const response = await instance
            .get('fund', { params });
        return response.data;
    },
    async getOptions(options) {
        const response = await instance.get('fund/options', {
            params: {
                tags: options.tags || null,
            },
        });
        return response.data;
    },
    async getSearchResults(options) {
        const response = await instance.get('fund/search', {
            params: {
                '-categories': options.excludeCategories || null,
                '-tags': options.excludeTags || null,
                query: getAdvancedQuery(options.query, options.includeTerms, options.excludeTerms),
                page: options.page || 1,
                per_page: options.per_page || 6,
                tags: options.includeTags || null,
                categories: options.includeCategories || null,
            },
        });
        return response.data;
    },
    getUTMSourceParam(fundURL) {
        let linkParts = fundURL.split('?');
        if (linkParts.length <= 1) {
            return '';
        }
        let utmParams = linkParts[1].split('&');
        let source = utmParams[1].split('=');
        return source[1] ? source[1]: '';
    }
}

export default {
    create(apiKey, host = 'https://data.givingcompass.org/v2') {
        if (!apiKey) {
            throw new Error('Client API key is required');
        }
        instance = axios.create({
            baseURL: host,
            headers: {
                'x-api-key': apiKey
            }
        });
        return service;
    }
}
